"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.maybeEarlyRequest = void 0;

var _q = _interopRequireDefault(require("q"));

var maybeEarlyRequest = function maybeEarlyRequest(requestName, requestCb) {
  var earlyRequest = requestName && window.quickFetch && window.quickFetch.getRequestStateByName(requestName);

  if (earlyRequest) {
    var earlyRequestPromise = new _q.default.Promise(function (resolve, reject) {
      earlyRequest.whenFinished(function (result) {
        resolve(result);
        window.quickFetch.removeEarlyRequest(requestName);
      });
      earlyRequest.onError(function () {
        // retry the request
        requestCb().then(resolve).catch(function (err) {
          reject(err);
        });
        window.quickFetch.removeEarlyRequest(requestName);
      });
    });

    if (window.newrelic) {
      window.newrelic.setCustomAttribute(requestName + "-early-request-used", Boolean(earlyRequest.finished));
    }

    return earlyRequestPromise;
  }

  return requestCb();
};

exports.maybeEarlyRequest = maybeEarlyRequest;